import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppProfile } from 'src/app/shared/app-profile/app-profile';

@Injectable({
  providedIn: 'root'
})
export class DeviceSearchService {
  private apiUrl = this.appProfile.ampmUs+'/ems/fhir/'+this.appProfile.org+'/Device/_search';
  private headers = new HttpHeaders({
    'X-tenant-Id': this.appProfile.tenant,
    'api-version': '1.0.0',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${this.authService.accessToken}`,
  });
  constructor(private http: HttpClient,private authService: AuthService, private appProfile: AppProfile ) { }
  searchDevices(serialNumber: string): Observable<any> {
    const body = {
      serialNumber: serialNumber,
      pagination: {
        page: 1,
        _count: 10
      },
      sorting: {
        sortField: 'createdDate',
        sortDirection: 'Asc'
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: this.headers }).pipe(
      map(response => {
        if (response.total > 0) {
          return response;
        } else {
          throw new Error('No results found or link/total conditions not met.');
        }
      })
    );
  }
}
